import { apiSlice } from "../apiSlice";

const secondaryUrl = "ReceiveFeedback.webapi";
const feedbackExtendedSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    submitFeedbackByQuestionId: builder.mutation({
      query: ({ question_id, feedback }) => ({
        url: `${secondaryUrl}/`,
        method: "POST",
        body: { question_id: question_id, feedback: feedback }, // Pass the body here for POST
      }),
    }),
    // Full feedback payload, same shape the other apps send
    submitFeedback: builder.mutation({
      query: (payload) => ({
        url: `${secondaryUrl}/`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useSubmitFeedbackByQuestionIdMutation,
  useSubmitFeedbackMutation,
} = feedbackExtendedSlice;